import { Linesheet } from '@/features/linesheet/types';
import { CheckList } from './';
import { CurrencyCode } from '../finance';

export const titles = {
  CONTACT: 'Fill in contact details',
  CURRENCY: 'Select a base currency',
  HEADER: 'Fill in the title, date and notes',
  PRODUCT_FIRST: 'Add your first product',
  PRODUCT_IMAGES: 'Add product images',
  PRODUCT_NAMES: 'Add product names',
  PRODUCT_PRICES: 'Add prices',
  PRODUCT_PROPS: 'Add and complete properties',
};

export default [
  {
    title: titles.HEADER,
    isComplete: data => data.title && data.notes,
    meta: {
      category: 'Linesheet Information',
    },
  },
  {
    title: titles.CONTACT,
    isComplete: data => !!data.contact.contactName
      && !!data.contact.address
      && !!data.contact.email
      && !!data.contact.phoneNumber,
    meta: {
      category: 'Linesheet Information',
    },
  },
  {
    title: titles.CURRENCY,
    isComplete: data => !!data.currencies.length,
    meta: {
      category: 'Linesheet Information',
    },
  },
  {
    title: titles.PRODUCT_FIRST,
    isComplete: data => !!(data.products || []).length,
    meta: {
      category: 'Product Checklist',
    },
  },
  {
    title: titles.PRODUCT_NAMES,
    isComplete: data => (
      data.products.length && !data.products
        .filter((p: any) => !p.name.trim())
        .length
    ),
    meta: {
      category: 'Product Checklist',
    },
  },
  {
    title: titles.PRODUCT_IMAGES,
    isComplete: data => (
      data.products.length
        && data.products.find(p => {
            const hasAssets = p.assets && p.assets.length;
            const hasProductAssets = p.product
              && p.product.assets
              && p.product.assets.length;
            return hasAssets || hasProductAssets;
          })
    ),
    meta: {
      category: 'Product Checklist',
    },
  },
  {
    title: titles.PRODUCT_PROPS,
    isComplete: data => (
      data.products.length
        && !data.products.find(({ properties }) => (
          !properties.length
            || !!properties.find(prop => !prop.key || !prop.value)
        ))
    ),
    meta: {
      category: 'Product Checklist',
    },
  },
  {
    title: titles.PRODUCT_PRICES,
    isComplete: data => (
      // if any conditions are met below, then it is not complete
      data.products.length && !data.products.find(({
        price_retail,
        price_wholesale,
      }) => {
        let hasNoPrice = false;
        for (const currency in price_retail) {
          const code = currency as CurrencyCode;
          if (!Number(price_retail[code])) {
            hasNoPrice = true;
          }
        }
        for (const currency in price_wholesale) {
          const code = currency as CurrencyCode;
          if (!Number(price_wholesale[code])) {
            hasNoPrice = true;
          }
        }
        return hasNoPrice;
      })
    ),
    meta: {
      category: 'Product Checklist',
    },
  },
] as Array<CheckList<Linesheet>>;
